import React, { useEffect, useRef } from "react";

const CyberMatrixHero = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");
    if (!ctx) return;

    // Set canvas to full screen
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener("resize", resizeCanvas);

    // Matrix characters
    const chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789$#@%&*";
    const fontSize = 16;
    const columns = Math.ceil(canvas.width / fontSize);
    
    // Array to track the y position of each column
    // Initialize with random negative values so they fall naturally at start
    const drops = Array(columns).fill(0).map(() => Math.random() * -100);

    const draw = () => {
      // Semi-transparent black to create fade trail effect
      ctx.fillStyle = "rgba(0, 0, 0, 0.05)"; // Deep black for better contrast
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.font = `${fontSize}px 'JetBrains Mono', monospace`;
      
      for (let i = 0; i < drops.length; i++) {
        // Random character
        const text = chars[Math.floor(Math.random() * chars.length)];
        
        // Randomly highlight some characters in white/bright green
        if (Math.random() > 0.98) {
            ctx.fillStyle = "#FFFFFF";
        } else if (Math.random() > 0.95) {
             ctx.fillStyle = "#00FF41"; // Matrix Green (Bright)
        } else {
             ctx.fillStyle = "#008F11"; // Matrix Green (Dark)
        }

        ctx.fillText(text, i * fontSize, drops[i] * fontSize);

        // Reset drop to top randomly
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }

        // Increment y position
        drops[i]++;
      }
    };

    const interval = setInterval(draw, 33); // ~30fps

    return () => {
      clearInterval(interval);
      window.removeEventListener("resize", resizeCanvas);
    };
  }, []);

  return (
    <div className="absolute inset-0 z-0 h-full w-full bg-dark overflow-hidden pointer-events-none">
      <canvas
        ref={canvasRef}
        className="absolute inset-0 block h-full w-full opacity-30"
      />
      {/* Vignette Overlay for depth */}
      <div className="absolute inset-0 bg-gradient-to-b from-dark/80 via-transparent to-dark pointer-events-none"></div>
    </div>
  );
};

export default CyberMatrixHero;
